import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/anim.css";
import AuthProvider from "./context/AuthProvider";
import UserProvider from "./context/UserProvider";
import ThemeProvider from "./context/ThemeProvider";
import { ProfilePictureProvider } from "./AppPages/util/ProfilePicture";
import PopUpProvider from "./context/PopUpProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
if (process.env.NODE_ENV === "development" && window.location.pathname === "/__preview/leaderboard") {
  const LeaderboardPreview = require("./AppPages/UserPage/LeaderBoardPage/LeaderboardPreview").default;
  root.render(<BrowserRouter><LeaderboardPreview /></BrowserRouter>);
} else root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <UserProvider>
          <BrowserRouter>
            <ProfilePictureProvider>
              <PopUpProvider>
                <App />
              </PopUpProvider>
            </ProfilePictureProvider>
          </BrowserRouter>
        </UserProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
